import styled from 'styled-components';

import PrimaryButton from '../../buttons/basicButtons/PrimaryButton.sc';

export const ModalContent = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconWarning = styled.img`
  width: 60px;
  height: 60px;
  display: block;
`;

export const Title = styled.h3`
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 15px 0 0;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const Description = styled.div`
  text-align: center;
  font-size: 1rem;
  line-height: 1.733rem;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-top: 15px;
  /* ie11 */
  max-width: 100%;
`;

export const ButtonOk = styled(PrimaryButton)`
  width: auto;
  min-width: 200px;
  margin-top: 30px;
  padding: 0 10px;
  font-size: 1rem;
`;
